import React from 'react'


const NotFound = () => (
    <div>The item you were looking for was not found.  Please check your path and try again.</div>
)

export default NotFound